export var commonPinkPeopleColorsTokens = {
  'colors-pink-people': 'var(--lmn-ds-colors-pink-people-400)',
  'colors-pink-people-50': '#fee6f2',
  'colors-pink-people-100': '#fbb3d8',
  'colors-pink-people-200': '#f980be',
  'colors-pink-people-300': '#f64da4',
  'colors-pink-people-400': '#f2007d',
  'colors-pink-people-500': '#da0071',
  'colors-pink-people-600': '#c20064',
  'colors-pink-people-700': '#a90058',
  'colors-pink-people-800': '#91004b'
};